export const DISCLAIMER =
  "*В зависимости от LLM-модели, рекомендации могут отличаться и будут предположением, а не 100% инструкцией к выполнению";
